export default {
	GET_USAGE: ({ crewId, date }) => `/plan/usage?crewId=${crewId}${date ? `&date=${date}` : ""}`,
};
